import axios from "axios";
import {  GetAllReportProvvedimentiFiltersDTO, GetAllReportProvvedimentiResponseData } from "./dto";
import { ReportProvvedimentiService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class ReportProvvedimentiImpl implements ReportProvvedimentiService {

    public GetAllReportProvvedimenti(filters: GetAllReportProvvedimentiFiltersDTO): Promise<GetAllReportProvvedimentiResponseData[]> {
        return axios.get("/api/monitoring/starting-phase", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                from: filters.from ? filters.from : '',
                to: filters.to ? filters.to : ''
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}